import { mm2px } from "./utils/math";

// LOCAL
export const LOAD_FROM_LOCAL_WHEN_INIT = false;
export const AUTO_SAVE_WHEN_CHANGE = false;

// UI enhance
export const HOVER_OBJECT_CORNER = true;
export const HOVER_OBJECT_CONTROL = true;

// Image ClipPath bug?
// https://github.com/fabricjs/fabric.js/issues/5639
// but will cause low performance
export const IMAGE_CLIPPATH_QUALITY = true;

export const MAX_HISTORY_LENGTH = 100;

export const PANEL_WIDTH = 360;
export const SETTER_WIDTH = 280;

export const CAPTURE_SUBTARGET_WHEN_DBLCLICK = false;

export const LOAD_JSON_IGNORE_LOAD_FONT = false;


export const TEMPLATE_SIZES = [
  { value: 0, size: [100, 100], label: '100mm * 100mm' },
  { value: 1, size: [70, 50], label: '70mm * 50mm' },
  { value: 2, size: [70, 40], label: '70mm * 40mm' },
  { value: 3, size: [70, 20], label: '70mm * 20mm' },
]